module.exports = __webpack_public_path__ + "static/img/service02.cc82aadf.png";